"use strict";
/**
 * A function which receives a depo state's `stores` object, iterates over it
 * and copies actions from every store into a new "actions" object, with each
 * store's actions namespaced by its store name.
 *
 * @param stores The `stores` object of a depo state instance.
 * @return A new object containing all objects from all stores, namespaced by store name.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var createActionsObject = function (stores) {
    return Object.keys(stores).reduce(function (actionsObjectUnderConstruction, storeName) {
        var store = stores[storeName];
        actionsObjectUnderConstruction[storeName] = store.actions;
        return actionsObjectUnderConstruction;
    }, {});
};
exports.default = createActionsObject;
//# sourceMappingURL=createActionsObject.js.map